import { getRequest } from ".";
import apiEndpoints from "./apiEndpoints";

export const getAllTechnologies = () =>
  getRequest(apiEndpoints.technologies.allTechnologies);
